import { useMutation, useQueryClient } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';
import type { UpdateMenuOrderRequest } from '../types/menu';

/**
 * PATCH /api/eraf/menus/order — 벌크 순서 변경
 * 성공 시 tree / flat 캐시 무효화
 */
export function useReorderMenus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateMenuOrderRequest) => menuApi.reorder(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['menu-management', 'tree'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'flat'] });
      void qc.invalidateQueries({ queryKey: ['catalog'] });
    },
  });
}
